import React, { useState } from 'react';
import { TextField, Box } from '@mui/material';
import ActionDialog from 'common/components/ActionDialog';
import { useTranslation } from 'services/localization/useTranslation';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	handleAdd: (name: string) => void;
	existingFieldLabels: string[];
}

const NewSpecificationDialog = (props: Props) => {
	const { t } = useTranslation();
	const [specificationName, setSpecificationName] = useState('');

	const labelAlreadyExists =
		!!specificationName && props.existingFieldLabels.includes(specificationName);

	const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSpecificationName(e.target.value);
	};

	return props.isOpen ? (
		<ActionDialog
			title={t('inventory.newSpecificationDialogTitle', 'Add new specification')}
			headerVariant="contained"
			btnActions={{
				primary: {
					text: t('common:actions.add'),
					onClick: () => props.handleAdd(specificationName),
					disabled: !specificationName.length || labelAlreadyExists,
				},
				secondary: {
					text: t('common:actions.cancel'),
					onClick: props.onClose,
				},
			}}
			onClose={props.onClose}
		>
			<Box mt={1}>
				<TextField
					autoFocus
					label={t('inventory.newSpecificationDialogInputLabel', 'Specification name')}
					variant="outlined"
					value={specificationName}
					onChange={handleNameChange}
					helperText={
						labelAlreadyExists &&
						t('inventory.specificationAlreadyExists', 'Specification with this name already exists')
					}
				/>
			</Box>
		</ActionDialog>
	) : null;
};

export default NewSpecificationDialog;
